import { MicrosoftAccessCopySink } from '../../model/pipeline/copysink/microsoft-access.copysink';
import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { MicrosoftAccessCopySource } from 'app/model/pipeline/copysource/microsoft-access.copysource';
import { getOdbcLinkedServiceConfigControls } from './odbc-metadata';
import { GlobalVariables } from 'app/services/globals';
import { CommonResourceKind, DataSourceOptionKind } from '@powerquery/mashup-editor-client';

export const microsoftAccessMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.microsoftAccess.linkedServiceType,
    displayName: stringResources.MicrosoftAccess_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-microsoft_access'
    },
    isOnPremises: true,
    isFirstClass: true,
    supportFirstClassParameterExperience: true,
    tableColumnNameQuotes: ['"', '"'],
    supportPreCopyScript: true,
    supportDatasetV2: true,
    category: ['Database'],
    copySourceTypes: [Metamodel.modelFor(MicrosoftAccessCopySource).name],
    copySinkTypes: [Metamodel.modelFor(MicrosoftAccessCopySink).name],
    supportedInTrident: GlobalVariables.enableOPDG,
    supportAutoFillCopilotInput: GlobalVariables.enableOPDG,
    isKnownInPipelineContext: GlobalVariables.enableOPDG,
    supportCopyJobSource: GlobalVariables.enableOPDG,
    supportCopyJobSink: GlobalVariables.enableOPDG,
    supportedJobModesAsSource: GlobalVariables.copyJobIncrementalCopyPhase2 ? undefined : ['Batch'],
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'MicrosoftAccess' as CommonResourceKind
    },
    supportOPDG: GlobalVariables.enableOPDG,
    opdgOnly: true,
    controls: getOdbcLinkedServiceConfigControls()
};
